import { defineMessages } from "react-intl";

const messages = defineMessages({
  applyButton: {
    id: "view.selectBar.addRemove.groups.apply",
    defaultMessage: "Apply",
    description: "Apply button label",
  },
  cancelButton: {
    id: "view.selectBar.addRemove.groups.cancel",
    defaultMessage: "Cancel",
    description: "Cancel button label",
  },
  create: {
    id: "view.selectBar.addRemove.groups.createButton",
    defaultMessage: "+ Create new group",
    description: "Create new group button label",
  },
  description: {
    id: "view.selectBar.addRemove.groups.description",
    defaultMessage:
      "Please note that adding or removing records from groups may affect some users' ability to access those records.",
    description: "Modal description",
  },
  groupsPlaceholder: {
    id: "view.selectBar.addRemove.groups.placeholder",
    defaultMessage: "Select",
    description: "Placeholder displayed in a Group select field",
  },
  selectGroup: {
    id: "view.selectBar.addRemove.groups.selectGroup.label",
    defaultMessage: "Select group(s)",
    description: "Group selector label",
  },
  selectOne: {
    id: "view.selectBar.addRemove.groups.selectOne.label",
    defaultMessage: "Select one",
    description: "Operation selector label",
  },
  title: {
    id: "view.selectBar.addRemove.groups.title",
    defaultMessage: "Add to / remove from groups",
    description: "Modal title",
  },
});

export default messages;
